import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { VolunteerTaskSeries } from '../../models';
import { NgForm } from '@angular/forms';

export const convertNumericFields = (s:VolunteerTaskSeries) => {
  const toNumber = (value:any) => value == null ? null : parseInt(value);
  s.id = toNumber(s.id);
  s.maxCnt = toNumber(s.maxCnt);
  s.defaultDurationHrs = toNumber(s.defaultDurationHrs);
  s.defaultIntervalHrs = toNumber(s.defaultIntervalHrs);
}

@Component({
  selector: 'app-volunteer-task-series',
  styleUrls: ['./volunteer-task-series.component.scss'],
  templateUrl: './volunteer-task-series.component.html',
})
export class VolunteerTaskSeriesComponent {

  @Input('series') set seriesSetter( s: VolunteerTaskSeries){
    const series = s || new VolunteerTaskSeries();
    this.tmpSeries = JSON.parse(JSON.stringify(series));    
    convertNumericFields(this.tmpSeries);
  };

  @Output('series') seriesChange$ = new EventEmitter<VolunteerTaskSeries>();
  @Output('maxCnt') maxCntChange$ = new EventEmitter<number|null>();
  @Output('interval') intervalChange$ = new EventEmitter<number|null>();
  @Output('duration') durationChange$ = new EventEmitter<number|null>();
  
  @ViewChild("seriesForm") form: NgForm;

  taskIntervalOptions = {
    [1*24]: '1 day',
    [2*24]: '2 days',
    [3*24]: '3 days',
    [4*24]: '4 days',
    [5*24]: '5 days',
    [6*24]: '6 days',
    [7*24]: '1 week',
    [2*7*24]: '2 weeks',
    [3*7*24]: '3 weeks',
    [4*7*24]: '4 weeks',
    [8*7*24]: '8 weeks',
    [12*7*24]: '12 weeks',
  };

  taskDurationOptions = this.taskIntervalOptions;

  tmpSeries: VolunteerTaskSeries;

}
